import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, { parseFractionLikeInput, formatFractionLatexCore } from "../../../../components/inputs/FractionInput";
import { pick, range } from "../commonSolidPi";

export function generateTask() {
  const r = pick(range(2, 10));
  const k = 4 * r * r;
  return { type: "SphereRadiusFromSurfaceAreaTask", data: { r, k } };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginBottom: 12 }}>
      Pole powierzchni kuli jest równe <InlineMath math={`${data.k}\\pi`} />. Oblicz promień tej kuli.
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return <FractionInput value={userAnswer} onChange={onChange} disabled={disabled} label="r" placeholder="np. 5" />;
}

export function checkAnswer({ data }, userAnswer) {
  const parsed = Number.isFinite(userAnswer?.parsed) ? userAnswer.parsed : parseFractionLikeInput(userAnswer?.raw || "");
  return Number.isFinite(parsed) && Math.abs(parsed - data.r) <= 1e-6;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`r=${data.r}`} />;
}

export function renderUserAnswer(userAnswer) {
  const raw = userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`r=${formatFractionLatexCore(raw) || raw}`} />;
}

export function renderExplanation({ data }) {
  const { r, k } = data;
  return (
    <div style={{ display: "grid", rowGap: 8 }}>
      <p><strong>Krok 1.</strong> Zapisujemy wzór na pole powierzchni kuli.</p>
      <BlockMath math={`P=4\\pi r^2`} />
      <p><strong>Krok 2.</strong> Podstawiamy dane i skracamy przez <InlineMath math={`\\pi`} />.</p>
      <BlockMath math={`${k}\\pi=4\\pi r^2`} />
      <BlockMath math={`${k}=4r^2`} />
      <p><strong>Krok 3.</strong> Wyznaczamy promień.</p>
      <BlockMath math={`r^2=${r * r}\\quad\\Rightarrow\\quad r=${r}`} />
      <p><strong>Odpowiedź:</strong> <InlineMath math={`r=${r}`} />.</p>
    </div>
  );
}
